export const YEAR = 2019;

export const DIESEL_EMISSIONS_IN_LBS_PER_GAL = 22.45; // http://www.patagoniaalliance.org/wp-content/uploads/2014/08/How-much-carbon-dioxide-is-produced-by-burning-gasoline-and-diesel-fuel-FAQ-U.S.-Energy-Information-Administration-EIA.pdf

export const GASOLINE_EMISSIONS_IN_LBS_PER_GAL = 19.36; // http://www.patagoniaalliance.org/wp-content/uploads/2014/08/How-much-carbon-dioxide-is-produced-by-burning-gasoline-and-diesel-fuel-FAQ-U.S.-Energy-Information-Administration-EIA.pdf
